(function ($, root) {
	"use strict";

	$.config();

	$.onloadWithTimeout = function (callback) {
		//do the following stuff right after everything (including images ) are loaded to page, or timeout

		//after everything is loaded:
		$(window).on("load", function () {
			if (!window.rdo.loader.loaded) {
				callback();
			}
		});

		setTimeout(function () {
			if (!window.rdo.loader.loaded) {
				callback();
			}
		}, window.rdo.loader.timeout);
	};

	$.fn.extend({
		checkScreen: function () {
			window.rdo.page.pagewidth = $(this).width();
			window.rdo.page.pageheight = $(this).height();

			switch (true) {
				case window.rdo.page.pagewidth < 577:
					window.rdo.page.orientation = "smartphone";

					// window.rdo.carousel.timeout = 3000;
					break;
				case window.rdo.page.pagewidth < 769:
					window.rdo.page.orientation = "lanscape-smartphone";

					break;
				case window.rdo.page.pagewidth < 993:
					window.rdo.page.orientation = "medium";

					break;
				case window.rdo.page.pagewidth < 1201:
					window.rdo.page.orientation = "large";

					break;
				case window.rdo.page.pagewidth < 1367:
					window.rdo.page.orientation = "xlarge";

					break;
				default:
					window.rdo.page.orientation = "xxlarge";
			}

			if (
				navigator.appVersion.indexOf("MSIE 10") !== -1 || // ie 10
				(!!window.MSInputMethodContext && !!document.documentMode) //ie 11
			) {
				window.rdo.ie = true;
				$("html").addClass("ie");
			}

			var md = new MobileDetect(window.navigator.userAgent);

			// $.logger('mobile', md.mobile());
			if (md.mobile()) {
				$("body").addClass("isMobile");
				window.rdo.isMobile = true;
				window.rdo.clickevent = "click touchend";

				// $('.banner').show();

				// $('.copyright').html('ismobile');
				if (md.os() == "AndroidOS") {
					window.rdo.mobileClient = "android";
					// $('.banner a').attr('href', window.rdo.appurl.android);
					// $('.copyright').html('ismobile : android');
				}
				if (md.is("iPhone")) {
					window.rdo.mobileClient = "ios";
					// $('.banner a').attr('href', window.rdo.appurl.ios);
					// $('.copyright').html('ismobile : iphone');
				}
				// location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
			} else {
				$("body").removeClass("isMobile");
				window.rdo.clickevent = "click";
				window.rdo.isMobile = false;
				// $('.banner').hide();
				// $('.copyright').html('not mobile');
			}

			$.resizeYoutubeVideo();
		},
	});

	$.onresizeWithTimeout = function (callback) {
		//do the following stuff right after everything (including images ) are loaded to page, or timeout

		var timeoutResize;
		timeoutResize = setTimeout(function () {
			callback();
		}, 200);

		$(window)
			.resize(function (event) {
				clearTimeout(timeoutResize);
				$(window).checkScreen();
				timeoutResize = setTimeout(function () {
					callback();
				}, window.rdo.loader.timeout);
			})
			.trigger("resize");
	};

	$.killLoading = function () {
		window.rdo.loader.pageOver = $("#loadingicon");
		$.hidePageOver();
	};

	$.showPageOver = function () {
		window.rdo.loader.pageOver.css("display", "flex").hide().fadeIn();
	};
	$.hidePageOver = function () {
		// console.log('hiding',window.rdo.loader.pageOver.length);
		window.rdo.loader.pageOver.fadeOut();
	};

	// disable scroll when the menu is open
	// animet the icon bar

	// in mainpage, scroll up when clicked the logo at the footer. instead of refreshing the page.
	$("#scrool-logo").click(function () {
		$("html,body").animate(
			{
				scrollTop: 0,
			},
			500,
			"swing"
		);
	});

	//submit form on keyboard enter & return:
	$("#search._form").on("keyup keypress", function (e) {
		var keyCode = e.keyCode || e.which;
		if (keyCode === 13) {
			e.preventDefault();
			$(this).submit();
		}
	});

	//resize youtube videos to fit width in the correct ratio:
	$.resizeYoutubeVideo = function () {
		//if it's a google video iframe?
		$("iframe[src^='https://www.youtube.com/embed/']").height(function () {
			//resize for orginial ratio
			var ratio = $(this).attr("orgheight") / $(this).attr("orgwidth");
			// console.log('ratio',ratio);
			if (!ratio) {
				ratio = 9 / 16;
			}
			return $(this).width() * ratio;
		});
	};

	$.resetYoutubeVideo = function () {
		//if it's a google video iframe?
		$("iframe[src^='https://www.youtube.com/embed/']").height(function () {
			$(this)
				.attr("orgwidth", $(this).attr("width"))
				.attr("orgheight", $(this).attr("height"))
				.attr("width", "100%")
				.removeAttr("height");
		});
	};

	$("#mc_subscribe_form").submit(function (event) {
		// Stop form from submitting normally
		event.preventDefault();
		window.rdo.loader.pageOver.show();

		// Get some values from elements on the page:
		var $form = $(this),
			email_address = $("#mc_email").val();

		var data = {
			email_address: email_address,
		};
		$("#mc_email").prop("disabled", true);

		$.ajax({
			url: "https://api.revsrv.com/service.RevolviaMC/",
			type: "POST",
			data: data,
			success: function (result) {
				$("#mc_email").val("");
				$("#mc_email").prop("disabled", false);
				Swal.fire({
					title: "Kaydını Aldık!",
					text: "Son bir şey: şimdi e-posta kutuna gelen onay mailinden kaydını onaylaman gerek.",
					type: "success",
					confirmButtonText: "Tamam",
				});

				fbq("track", "Lead");
				window.rdo.loader.pageOver.hide();

				//window.location.replace("/tesekkurler");
			},
			failure: function () {
				Swal.fire({
					title: "Bir sorun oluştu.",
					text: "Kaydınız teknik bir sorun sebebiyle alınamadı. Lütfen daha sonra tekrar deneyin",
					type: "error",
					confirmButtonText: "Tamam",
				});
				$("#mc_email").prop("disabled", false);
				window.rdo.loader.pageOver.hide();
			},
		});
	});

	//  clients carousel

	$(window).resize(function () {
		$(window).checkScreen();
	});

	$(function () {
		"use strict";

		setTimeout(function () {
			$("body").css("opacity", 1);
		}, 1000);

		$("#header-menu .menu_item_wpglobus_menu_switch > a").removeAttr("href");

		$.onloadWithTimeout(function () {
			window.rdo.loader.loaded = true;
			$.killLoading();
			$.resetYoutubeVideo();

			$(window).checkScreen();

			$(".owl-carousel").owlCarousel({
				items: 6,
				loop: true,
				autoplay: true,
				dots: false,
				// autoplayTimeout: 5000,
				autoplayHoverPause: true,
				// center: true,
				responsive: {
					0: {
						items: 2,
					},
					768: {
						items: 3,
					},
					992: {
						items: 4,
					},
					1199: {
						items: 6,
					},
				},
			});
		});

		window.rdo.nav.click(function () {
			//setTimeout(function () {
			if (!window.rdo.nav.menu_closed) {
				$("body").css({
					overflow: "hidden",
				});
				$(".icon-bar:nth-child(3)")
					.addClass("zero-opacity")
					.removeClass("full-opacity");
				$(".icon-bar:nth-child(1)")
					.addClass("counterclockwise-turn")
					.removeClass("zero-alignment");
				$(".icon-bar:nth-child(2)")
					.addClass("clockwise-turn")
					.removeClass("zero-alignment");
				window.rdo.nav.menu_closed = 1; //menu is closed
			} else {
				$("body").css({
					overflow: "auto",
				});
				$(".icon-bar:nth-child(3)")
					.addClass("full-opacity")
					.removeClass("zero-opacity");
				$(".icon-bar:nth-child(1)")
					.addClass("zero-alignment")
					.removeClass("counterclockwise-turn");
				$(".icon-bar:nth-child(2)")
					.addClass("zero-alignment")
					.removeClass("clockwise-turn");

				window.rdo.nav.menu_closed = 0; //menu is opened
			}
			//}, 1000);
		});

		// hide header when scrolled
		window.rdo.header.headroom({
			offset: 205,
			tolerance: 0,
			classes: {
				initial: "animated",
				pinned: "slideInDown",
				unpinned: "slideOutUp",
				notTop: "light",
			},
		});

		window.rdo.LazyLoad = new LazyLoad({
			threshold: 500,
			elements_selector: "img.lazy,div.lazy,a.lazy",
			throttle: 200,
		});

		if ($(".navbar-collapse").hasClass("in")) {
			window.rdo.nav.menu_closed = 0; // menu is open
		}

		setTimeout(function () {
			var productList = $(".list-container");
			productList
				.isotope({
					itemSelector: ".lists",
					gutter: 10,
				})
				.isotope("layout");
		}, 500);

		$.startInfiniteLoader();
	});
})(jQuery);

import "./core.js";
// })(jQuery, this);
